<template>
    <div class="valuation-layout__amount">
        <template v-if="valuationHasError">
            <h3 class="valuation-layout__amount--title">{{ failedValuationTitle }}</h3>
            <p class="valuation-layout__text">{{ failedValuationText }}</p>
        </template>
        <template v-else-if="valuationAmountAsFloat <= 0">
            <h3 class="valuation-layout__amount--title">{{ failedValuationTitle }}</h3>
            <p class="valuation-layout__text">{{ failedValuationText }}</p>
        </template>
        <template v-else>
            <h3 class="valuation-layout__amount--title">{{ valuationTitle }}</h3>
            <h4 class="valuation-layout__amount--figure">{{ formattedAmount }} </h4>
            <p class="valuation-layout__text">{{ valuationText }} </p>
        </template>
        <div v-if="showCta === true">
            <div v-if="step === 10" class="valuation-layout__cta-area">
                <button @click="bookAppointment()" class="btn btn--primary">Book an appointment</button>
                <a v-if="authenticated" href="/my-account" class="btn btn--primary-inverted  btn--full-width">
                    Visit My Account
                </a>
                <a v-else href="#create-account" class="btn btn--primary-inverted  btn--full-width">
                    Create Account
                </a>
            </div>
            <div v-else class="valuation-layout__cta-area">
                <button v-if="!valuationHasError && !bookingDetails && showExtendedValuation" @click="goToExtendedValuation()"
                    class="btn btn--primary">REFINED VALUATION</button>
                <button v-if="!bookingDetails" @click="bookAppointment()" class="btn btn--primary-inverted ">Book an
                    appointment</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    props: {
        showCta: {
            type: Boolean,
            default: true
        },
        valuationText: {
            type: String,
            default: '',
        },
        valuationTitle: {
            type: String,
            default: '',
        },
        failedValuationTitle: {
            type: String,
            default: 'Thank you for valuing your vehicle.',
        },
        failedValuationText: {
            type: String,
            default: 'Unfortunately we could not find a match for your registration.',
        },
        showExtendedValuation: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapState("Auth", ['authenticated']),
        ...mapState('ValuationTool', ['valuation', 'valuationHasError', 'bookingDetails', 'step']),
        ...mapGetters('ValuationTool', ['getValuation']),

        valuationAmountAsFloat() {
            if (this.valuationHasError) {
                return 0;
            }
            if (!this.getValuation) {
                return 0;
            }
            let valuation_amount = null;
            if (this.step === 4 || this.step === 6) {
                valuation_amount = this.getValuation.basic;
            } else if (this.step === 7) {
                valuation_amount = this.getValuation.service_history;
            } else if (this.step === 8) {
                valuation_amount = this.getValuation.mechanical_condition;
            } else if (this.step === 9 || this.step === 10) {
                valuation_amount = this.getValuation.final ?? this.getValuation.tchek;
            }
            valuation_amount = parseFloat(valuation_amount);
            if (isNaN(valuation_amount)) {
                return 0;
            }
            return valuation_amount;
        },
        formattedAmount() {
            return new Intl.NumberFormat('en-GB', {
                style: 'currency', currency: 'GBP', minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(this.valuationAmountAsFloat);
        },

    },
    methods: {
        ...mapActions("ValuationTool", ["goToExtendedValuation"]),

        bookAppointment() {
            this.$emit('show-book-now');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/components/Sections/ValuationAmount.vue